import { render } from "./CustomModal.vue?vue&type=template&id=46551b24&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"

import "./CustomModal.vue?vue&type=style&index=0&id=46551b24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46551b24"]])

export default __exports__